import Scripts from './Scripts';
import HeadScripts from './HeadScripts';

export default {
  Scripts,
  HeadScripts,
};
